import React from 'react'
import { dispatchSDK } from '@/utils/extend'

interface TrackContainerProps {
  trackId?: string
  properties?: object
  children: React.ReactNode
}

const TrackContainer = (props: TrackContainerProps) => {
  const { trackId, properties = {}, children } = props
  const trackedChildren = React.Children.map(children, (child: any) => {
    return React.cloneElement(child, {
      onClick: (args: any) => {
        // 是否存在追踪id，如果存在则上报
        if (trackId) {
          try {
            const timestamp = Math.round(new Date().getTime() / 1000)
            const event = trackId
            const data = JSON.stringify({ timestamp, event, properties })
            dispatchSDK('reportEvent', data)
          } catch (err) {
            console.log(err)
          }
        }
        if (child.props.onClick) {
          child.props.onClick(args)
        }
      },
    })
  })
  return <>{trackedChildren}</>
}

export default TrackContainer
